import React from "react";
import PropTypes from "prop-types";
import PositivacaoAreaDesktop from "./PositivacaoAreaDesktop";

function PositivacaoArea({ app, config }) {
  return <PositivacaoAreaDesktop app={app} config={config} />;
}

PositivacaoArea.defaultProps = {
  app: null,
  config: {},
};

PositivacaoArea.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoArea;
